enum PassportType {
  Ordinary = "ORDINARY",
  Service = "SERVICE",
  Official = "OFFICIAL",
  Provisional = "PROVISIONAL",
  Diplomatic = "DIPLOMATIC",
}

export function PassportTypeToCode(type: PassportType): string {
  switch (type) {
    case PassportType.Provisional:
      return "PP";
    case PassportType.Diplomatic:
      return "PD";
    case PassportType.Official:
      return "PO";
    case PassportType.Service:
      return "PS";
    default:
      return "P";
  }
}

export function PassportTypeFromCode(code: string): PassportType {
  switch (code.toUpperCase()) {
    case "PP":
      return PassportType.Provisional;
    case "PD":
      return PassportType.Diplomatic;
    case "PO":
      return PassportType.Official;
    case "PS":
      return PassportType.Service;
    default:
      return PassportType.Ordinary;
  }
}

export function PassportTypeToApi(type: PassportType): string {
  // TODO refactor
  // temporary solution - we should recieve options for passport type
  // from backend in future as part of AllowedDoc structure, which
  // would indicate which fields are required (and what are possible options).
  // -> this will be done as part of further refactoring, when we
  // drift away from a notion of Passport in webview towards general Travel document
  switch (type) {
    case PassportType.Provisional:
      return "PROVISIONAL";
    case PassportType.Diplomatic:
      return "DIPLOMATIC";
    case PassportType.Ordinary:
      return "ORDINARY";
    case PassportType.Official:
      return "OFFICIAL";
    case PassportType.Service:
      return "SERVICE";
  }
}

export default PassportType;
